export default __webpack_public_path__ + "static/sge-nav-964aa4e872489cba0e513c0693351bff.png";